import { Flex, Box } from "@chakra-ui/core";
import React from "react";
import { useLocation } from "react-router";
import Header from "../components/Header";
import { Navbar } from "../components/Navbar";
import useAuth from "../context/AuthContext";
import { CallToAction } from "./CallToAction";
import { Footer } from "./Footer";
import styles from "./Layout.module.css";
import { Helmet } from "react-helmet";

export const Layout = (props) => {
  const {
    state: { isAuthenticated },
  } = useAuth();

  return (
    <>
      {props.title && (
        <Helmet>
          <title>{props.title}</title>
          <meta
            name="description"
            content={props.description || "Find GrEEn Oppurtunities."}
          />
          <meta property="og:title" content={props.title || "GrEEn"} />
          <meta property="og:type" content="website" />
          <meta
            property="og:description"
            content={props.description || "Find GrEEn Oppurtunities."}
          />
          <meta
            property="og:image"
            content="https://greenghana.com.gh/static/media/hero.780555d8.jpg"
          />
          <meta property="og:url" content="https://greenghana.com.gh/" />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      )}
      {!props.hide && (
        <Flex>
          <Navbar />
          <Header />
        </Flex>
      )}
      <Flex
        direction="column"
        minH={props.hide ? "auto" : "100vh"}
        mt="0"
        overflowX="hidden"
      >
        <Box flex="1">{props.children}</Box>
        {!isAuthenticated && <CallToAction />}
        {!props.hide && <Footer />}
      </Flex>
    </>
  );
};
